var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVault(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 108,
    height: 108,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 108,
    height: 108,
    fill: "#E6007A",
    rx: 54
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M54 90c19.882 0 36-16.118 36-36S73.882 18 54 18 18 34.118 18 54s16.118 36 36 36Zm8.436-36.285c-1.582 1.588-2.93 3.557-2.93 5.799v11.11a5.4 5.4 0 1 1-10.8 0v-11.11c0-2.242-1.349-4.21-2.93-5.799a11.716 11.716 0 0 1-3.423-8.292c0-6.49 5.262-11.752 11.753-11.752 6.49 0 11.753 5.262 11.753 11.752 0 3.236-1.308 6.167-3.423 8.292Z",
    clipRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVault);
export default __webpack_public_path__ + "static/media/vault.1aa02aa17789e8cf6d405b6deddda21c.svg";
export { ForwardRef as ReactComponent };